<template>
    <div @mouseleave="close">
        <Analytics v-if="options.site_analytics" :scripts="options.site_analytics" />

        <div :class="{ header: true, white: overlayHeader, 'desktop-header': true, ignore: true }">
            <div class="header_con">
                <a class="logo" href="/" aria-label="FGQ home" @click.prevent="goPage('/')">
                    <img v-show="overlayHeader" :src="mainLogoSrc"
                        alt="FGQ globe logo" @error="mainLogoFailed = true">
                    <img v-show="!overlayHeader" :src="secondLogoSrc"
                        alt="FGQ globe logo" @error="secondLogoFailed = true">

                </a>
                <div class="menu">
                    <div :class="item.id" @mouseenter="(e) => getTab(e, item.id)" v-for="item in list" :key="item.id">
                        {{ item.name }}
                        <span class="line"></span>
                    </div>

                </div>
            </div>
            <div class="txt">
                <span>Build a good car for the common people</span>
                <div class="language-switch" data-testid="language-switch" aria-label="Chinese and English language switcher">
                    <button type="button" @click="switchLanguage">ZH</button>
                    <span class="divider">/</span>
                    <span class="active" aria-current="page">EN</span>
                </div>
            </div>

        </div>
        <div class="right" :style="{right:tabName?'0.26042vw':0}">
                    <div role="button" tabindex="0" aria-label="Open AI Customer Service"
                        @click="aiDialogVisible = true" @keydown.enter="aiDialogVisible = true">
                        <img src="@/assets/img/kefu2.png" alt="">
                        <span>AI Customer Service</span>
                    </div>
                    <router-link style="text-decoration: none;" :to="{ name: 'feadback' }" target="_blank">
                        <div class="feadback">
                            <img src="@/assets/img/feadback.png" alt="">
                            <span>Feedback</span>
                        </div>
                    </router-link>

                    <div @click="top" class="goTop" v-show="scrollPosition > 800">
                        <img src="@/assets/img/top.png" alt="">
                        <span>Back to Top</span>
                    </div>
                </div>
        <AiCustomerService :visible.sync="aiDialogVisible" />

                                            <span style="display: none;">{{ options.site_analytics }}</span>
        <headerMenu @close="close" :tabName="tabName" />
    </div>
</template>

<script>
import headerMenu from "@/components/headerMenu.vue"

import Analytics from "@/components/analytics.vue"
import AiCustomerService from "@/components/AiChatService.vue"
export default {
    components: {
        headerMenu,
        Analytics,
        AiCustomerService
    },
    data() {
        return {
            scrollPosition: 0,
            // list: [
            //     {
            //         name: '电动三轮车',
            //         id: 'ddsl'
            //     },
            //     {
            //         name: '电动生活',
            //         id: 'ddsh'
            //     },
            //     {
            //         name: '富贵科技',
            //         id: 'fgkj'
            //     },
            //     {
            //         name: '服务支持',
            //         id: 'fwzc'
            //     },
            //     {
            //         name: '关于我们',
            //         id: 'gywm'
            //     }
            // ],
            tabName: '',
            aiDialogVisible: false,
            mainLogoFailed: false,
            secondLogoFailed: false,
        }
    },
    computed: {
        pathName() {
            return this.$route.name
        },
        options() {
            return this.$store.state.dataInfo
        },
        list() {
            return this.$store.state.menuList.list
        },
        overlayHeader() {
            return this.scrollPosition <= 100 && !this.tabName && ['index', 'types', 'aboutUs', 'show'].includes(this.pathName)
        },
        mainLogoSrc() {
            return require('@/assets/img/logo3.png')
        },
        secondLogoSrc() {
            return require('@/assets/img/logo3.png')
        }
    },
    watch:{
        tabName(n){
            if(n){
                document.body.style.overflow = 'hidden';
               
            }else{
                document.body.style.overflow = '';
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        top() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
        },
        handleScroll() {
            this.scrollPosition = window.scrollY
        },
        goPage(url) {
            if (url) {
                this.$router.push(url)
                this.$emit('close')
            }
            this.close()

        },
        getTab(e, name) {
            this.tabName = name
            const fgkj = document.querySelector(".fgkj");
            const fwzc = document.querySelector(".fwzc");
            const gywm = document.querySelector(".gywm");
            const tagRect = fgkj.getBoundingClientRect();
            const tagRect2 = fwzc.getBoundingClientRect();
            const tagRect3 = gywm.getBoundingClientRect();
            this.$store.commit('setOffset', {
                fgkj: tagRect,
                fwzc: tagRect2,
                gywm: tagRect3
            })
        },
        switchLanguage(){
            const isLocal = ['8080', '8082'].includes(window.location.port) || ['127.0.0.1', 'localhost'].includes(window.location.hostname)
            const target = isLocal
                ? `${window.location.protocol}//${window.location.hostname}:8080/`
                : 'https://www.fgqslc.com/'
            window.location.assign(target)
        },
        close() {
           this.tabName = ''
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    width: calc(100vw -  0.26042vw);
    height: 72px;
    padding: 0px 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: #fff;

    .header_con {
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
            cursor: pointer;
            width: 70px;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            img {
                width: 66px;
                height: 66px;
                object-fit: contain;
            }
        }

        .menu {
            margin-left: 28px;
            display: flex;
            align-items: center;
            justify-content: center;

            >div {
                position: relative;
                padding: 0 36px;
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                white-space: nowrap;
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                height: 72px;

                .line {
                    position: absolute;
                    bottom: 0;
                    width: 79px;
                    background-color: #B00D16;
                    height: 3px;
                    display: none;

                }

                &:hover .line {
                    display: block;
                }

            }
        }
    }

    .txt {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        align-items: center;
        justify-content: center;
        display: flex;

        >div {
            align-items: center;
            justify-content: center;
            display: flex;
            white-space: nowrap;
        }

        .language-switch {
            gap: 6px;
            margin-left: 18px;
            padding: 6px 11px;
            border: 1px solid rgba(0, 0, 0, 0.35);
            border-radius: 999px;
            line-height: 1;
            white-space: nowrap;

            .active {
                color: #B00D16;
                font-weight: 700;
            }

            .divider {
                opacity: 0.45;
            }

            button {
                padding: 0;
                border: 0;
                background: transparent;
                color: inherit;
                font: inherit;
                cursor: pointer;
            }
        }

        img {
            cursor: pointer;
            width: 30px;
            height: 30px;
            margin-right: 15px;
        }
    }
}

// Keep the English desktop navigation compact and on one row.
// The .ignore class prevents the legacy px-to-viewport build step from
// enlarging the logo and spacing unpredictably at different screen scales.
.header.desktop-header.ignore {
    width: 100%;
    height: 72px;
    // The English logo is much narrower than the Chinese wordmark. Give the
    // left side its own inset so the whole logo + menu group lines up with
    // the Chinese header instead of being pulled toward the screen edge.
    padding-left: clamp(180px, 12.2vw, 250px);
    padding-right: clamp(72px, 5vw, 100px);
    gap: clamp(16px, 2vw, 36px);

    .header_con {
        flex: 0 1 auto;
        min-width: 0;
        justify-content: flex-start;

        .logo {
            width: 48px;
            height: 48px;

            img {
                width: 48px;
                height: 48px;
            }
        }

        .menu {
            flex: 0 1 auto;
            min-width: 0;
            margin-left: clamp(16px, 1.4vw, 28px);
            gap: 0;
            justify-content: center;

            >div {
                height: 72px;
                padding: 0 clamp(16px, 1.35vw, 26px);
                font-size: clamp(13px, 0.84vw, 16px);
                white-space: nowrap;
            }
        }
    }

    .txt {
        flex: 0 0 auto;
        font-size: clamp(13px, 0.84vw, 16px);
        white-space: nowrap;

        >span {
            white-space: nowrap;
        }

        .language-switch {
            margin-left: clamp(12px, 1.2vw, 18px);
            padding: 6px 10px;
        }
    }
}

@media screen and (max-width: 1440px) {
    .header.desktop-header.ignore {
        padding-left: clamp(96px, 9vw, 150px);
        padding-right: 48px;
        gap: clamp(12px, 1.2vw, 20px);

        .header_con .menu >div {
            padding: 0 clamp(12px, 1.05vw, 18px);
            font-size: clamp(12px, 1.05vw, 15px);
        }

        .txt {
            font-size: clamp(12px, 1vw, 15px);

            >span {
                display: inline;
            }
        }
    }
}

@media screen and (max-width: 1100px) {
    .header.desktop-header.ignore {
        padding: 0 28px;
    }
}

.white {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0));
    color: #fff;

    .header_con {
        .menu {
            div {
                color: #fff;
            }
        }
    }

    .txt {
        color: #fff;

        .language-switch {
            border-color: rgba(255, 255, 255, 0.65);

            .active,
            button {
                color: #fff;
            }
        }
    }
}
.online {
    padding: 20px 5px;
    display: flex;

    img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        flex-shrink: 0;
    }

    div {
        display: flex;
        flex-direction: column;
        font-family: MiSans;
        font-weight: 400;
        font-size: 22px;
        width: 260px;

        p {
            margin: 0;
            padding: 0;
            color: #000;
        }

        .tel {
            margin: 5px 0;
            color: #B00D16;
        }

        .go {
            margin-top: 20px;
            color: #B00D16;
            font-weight: 500;
            font-size: 18px;
            cursor: pointer;
        }
    }
}

.right {
    width: 76px;
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 98;
    background-color: #fff;
    border-radius: 15px 0 0 10px;
    padding: 10px 6px 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transition: all 0s;
    >div,
    .feadback {
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        font-family: MiSans;
        font-weight: 400;
        font-size: 12px;
        color: #2c2c2c;
        margin-bottom: 15px;
        font-weight: bold;
        text-decoration: none;

        &:last-child {
            margin: 0;
        }

        &:first-child {
            img {
                width: 22px;
            }
        }

        span {
            text-decoration: none;
            text-align: center;
            line-height: 1.35;
        }

        img {
            width: 20px;
            height: auto;
            margin-bottom: 5px;

        }
    }

    .goTop {
        margin-top: 15px !important;
    }
}

</style>
